@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_055_122_717)
public val Res.string.tips_hours: StringResource by lazy {
      StringResource("string:tips_hours", "tips_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367713, 26),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523633, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337876, 26),
      ))
    }

@delegate:ResourceContentHash(1_672_238_281)
public val Res.string.tips_my_empty: StringResource by lazy {
      StringResource("string:tips_my_empty", "tips_my_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367740, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523668, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337903, 73),
      ))
    }

@delegate:ResourceContentHash(758_030_543)
public val Res.string.tips_my_title: StringResource by lazy {
      StringResource("string:tips_my_title", "tips_my_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367826, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523786, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337977, 33),
      ))
    }

@delegate:ResourceContentHash(-697_307_037)
public val Res.string.tips_new: StringResource by lazy {
      StringResource("string:tips_new", "tips_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367868, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523836, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338011, 32),
      ))
    }

@delegate:ResourceContentHash(1_555_302_000)
public val Res.string.tips_next_period: StringResource by lazy {
      StringResource("string:tips_next_period", "tips_next_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367913, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523901, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338044, 40),
      ))
    }

@delegate:ResourceContentHash(2_141_571_998)
public val Res.string.tips_people: StringResource by lazy {
      StringResource("string:tips_people", "tips_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367958, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 523970, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338085, 35),
      ))
    }

@delegate:ResourceContentHash(1_087_886_853)
public val Res.string.tips_period_day: StringResource by lazy {
      StringResource("string:tips_period_day", "tips_period_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 367994, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524014, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338121, 27),
      ))
    }

@delegate:ResourceContentHash(538_661_044)
public val Res.string.tips_period_invalid: StringResource by lazy {
      StringResource("string:tips_period_invalid", "tips_period_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368026, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524050, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338149, 59),
      ))
    }

@delegate:ResourceContentHash(1_975_403_400)
public val Res.string.tips_period_range: StringResource by lazy {
      StringResource("string:tips_period_range", "tips_period_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368094, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524138, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338209, 45),
      ))
    }

@delegate:ResourceContentHash(-1_778_836_424)
public val Res.string.tips_period_week: StringResource by lazy {
      StringResource("string:tips_period_week", "tips_period_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368140, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524184, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338255, 32),
      ))
    }

@delegate:ResourceContentHash(-2_104_462_877)
public val Res.string.tips_pools_empty: StringResource by lazy {
      StringResource("string:tips_pools_empty", "tips_pools_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368177, 176),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524229, 280),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338288, 140),
      ))
    }

@delegate:ResourceContentHash(1_898_208_698)
public val Res.string.tips_pools_title: StringResource by lazy {
      StringResource("string:tips_pools_title", "tips_pools_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368354, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524510, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338429, 36),
      ))
    }

@delegate:ResourceContentHash(-1_844_143_721)
public val Res.string.tips_preview_enter_amount: StringResource by lazy {
      StringResource("string:tips_preview_enter_amount", "tips_preview_enter_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368399, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524571, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338466, 97),
      ))
    }

@delegate:ResourceContentHash(1_997_430_266)
public val Res.string.tips_preview_title: StringResource by lazy {
      StringResource("string:tips_preview_title", "tips_preview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368501, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524717, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338564, 54),
      ))
    }

@delegate:ResourceContentHash(2_030_318_557)
public val Res.string.tips_previous_period: StringResource by lazy {
      StringResource("string:tips_previous_period", "tips_previous_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368580, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524836, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338619, 48),
      ))
    }

@delegate:ResourceContentHash(17_108_304)
public val Res.string.tips_replaces: StringResource by lazy {
      StringResource("string:tips_replaces", "tips_replaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368629, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 524909, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338668, 89),
      ))
    }

@delegate:ResourceContentHash(-1_783_511_143)
public val Res.string.tips_saved: StringResource by lazy {
      StringResource("string:tips_saved", "tips_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368715, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 525067, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338758, 34),
      ))
    }

@delegate:ResourceContentHash(2_127_960_464)
public val Res.string.tips_tax_note: StringResource by lazy {
      StringResource("string:tips_tax_note", "tips_tax_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368758, 193),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 525130, 297),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338793, 189),
      ))
    }

@delegate:ResourceContentHash(-1_274_481_675)
public val Res.string.tips_title: StringResource by lazy {
      StringResource("string:tips_title", "tips_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368952, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 525428, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 338983, 26),
      ))
    }

@delegate:ResourceContentHash(-599_719_092)
public val Res.string.tips_waiting_for_hours: StringResource by lazy {
      StringResource("string:tips_waiting_for_hours", "tips_waiting_for_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 368983, 178),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 525463, 298),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339010, 142),
      ))
    }

@delegate:ResourceContentHash(1_984_744_106)
public val Res.string.tips_weight_invalid: StringResource by lazy {
      StringResource("string:tips_weight_invalid", "tips_weight_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369162, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 525762, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339153, 71),
      ))
    }

@delegate:ResourceContentHash(-808_834_706)
public val Res.string.tips_weights_hint: StringResource by lazy {
      StringResource("string:tips_weights_hint", "tips_weights_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369238, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 525870, 257),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339225, 109),
      ))
    }

@delegate:ResourceContentHash(-325_810_647)
public val Res.string.tips_weights_title: StringResource by lazy {
      StringResource("string:tips_weights_title", "tips_weights_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369356, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526128, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339335, 46),
      ))
    }

@delegate:ResourceContentHash(429_012_023)
public val Res.string.tips_your_share: StringResource by lazy {
      StringResource("string:tips_your_share", "tips_your_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369415, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526195, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339382, 47),
      ))
    }

@delegate:ResourceContentHash(2_077_033_678)
public val Res.string.todo_all_done: StringResource by lazy {
      StringResource("string:todo_all_done", "todo_all_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369534, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526354, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339509, 33),
      ))
    }

@delegate:ResourceContentHash(1_447_878_917)
public val Res.string.todo_all_done_hint: StringResource by lazy {
      StringResource("string:todo_all_done_hint", "todo_all_done_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369467, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526255, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339430, 78),
      ))
    }

@delegate:ResourceContentHash(791_992_095)
public val Res.string.todo_availability_due: StringResource by lazy {
      StringResource("string:todo_availability_due", "todo_availability_due", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369580, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526408, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339543, 73),
      ))
    }

@delegate:ResourceContentHash(1_570_526_632)
public val Res.string.todo_availability_fill: StringResource by lazy {
      StringResource("string:todo_availability_fill", "todo_availability_fill", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369650, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526498, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339617, 42),
      ))
    }

@delegate:ResourceContentHash(-798_984_569)
public val Res.string.todo_clock_reviews: StringResource by lazy {
      StringResource("string:todo_clock_reviews", "todo_clock_reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369739, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526615, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339702, 74),
      ))
    }

@delegate:ResourceContentHash(-1_467_351_406)
public val Res.string.todo_clock_reviews_action: StringResource by lazy {
      StringResource("string:todo_clock_reviews_action", "todo_clock_reviews_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369693, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526553, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339660, 41),
      ))
    }

@delegate:ResourceContentHash(931_349_219)
public val Res.string.todo_day_today: StringResource by lazy {
      StringResource("string:todo_day_today", "todo_day_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369822, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526734, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339777, 30),
      ))
    }

@delegate:ResourceContentHash(-269_149_155)
public val Res.string.todo_day_tomorrow: StringResource by lazy {
      StringResource("string:todo_day_tomorrow", "todo_day_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369853, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526781, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339808, 37),
      ))
    }

@delegate:ResourceContentHash(-1_437_854_827)
public val Res.string.todo_deadline: StringResource by lazy {
      StringResource("string:todo_deadline", "todo_deadline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369887, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526823, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339846, 33),
      ))
    }

@delegate:ResourceContentHash(-398_200_486)
public val Res.string.todo_earliest: StringResource by lazy {
      StringResource("string:todo_earliest", "todo_earliest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369985, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526937, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339936, 41),
      ))
    }

@delegate:ResourceContentHash(386_772_792)
public val Res.string.todo_earliest_named: StringResource by lazy {
      StringResource("string:todo_earliest_named", "todo_earliest_named", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 369925, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526869, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339880, 55),
      ))
    }

@delegate:ResourceContentHash(-5_177_222)
public val Res.string.todo_hours_to_confirm: StringResource by lazy {
      StringResource("string:todo_hours_to_confirm", "todo_hours_to_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370084, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527060, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340027, 77),
      ))
    }

@delegate:ResourceContentHash(168_122_983)
public val Res.string.todo_hours_to_confirm_action: StringResource by lazy {
      StringResource("string:todo_hours_to_confirm_action", "todo_hours_to_confirm_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370031, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 526991, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339978, 48),
      ))
    }

@delegate:ResourceContentHash(609_560_579)
public val Res.string.todo_marketplace: StringResource by lazy {
      StringResource("string:todo_marketplace", "todo_marketplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370218, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527238, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340165, 72),
      ))
    }

@delegate:ResourceContentHash(-1_405_514_638)
public val Res.string.todo_marketplace_action: StringResource by lazy {
      StringResource("string:todo_marketplace_action", "todo_marketplace_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370162, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527170, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340105, 59),
      ))
    }

@delegate:ResourceContentHash(2_126_896_641)
public val Res.string.todo_medical_expired: StringResource by lazy {
      StringResource("string:todo_medical_expired", "todo_medical_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370287, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527323, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340238, 72),
      ))
    }

@delegate:ResourceContentHash(1_857_894_718)
public val Res.string.todo_medical_expiring: StringResource by lazy {
      StringResource("string:todo_medical_expiring", "todo_medical_expiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370384, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527456, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340311, 81),
      ))
    }

@delegate:ResourceContentHash(106_255_423)
public val Res.string.todo_missing_pay: StringResource by lazy {
      StringResource("string:todo_missing_pay", "todo_missing_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370526, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527626, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340445, 64),
      ))
    }

@delegate:ResourceContentHash(662_227_975)
public val Res.string.todo_missing_pay_others: StringResource by lazy {
      StringResource("string:todo_missing_pay_others", "todo_missing_pay_others", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370470, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527570, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340393, 51),
      ))
    }

@delegate:ResourceContentHash(-214_974_900)
public val Res.string.todo_missing_takings: StringResource by lazy {
      StringResource("string:todo_missing_takings", "todo_missing_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370659, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527803, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340566, 64),
      ))
    }

@delegate:ResourceContentHash(-1_625_139_531)
public val Res.string.todo_missing_takings_action: StringResource by lazy {
      StringResource("string:todo_missing_takings_action", "todo_missing_takings_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370607, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527731, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340510, 55),
      ))
    }

@delegate:ResourceContentHash(-1_073_855_439)
public val Res.string.todo_my_shifts: StringResource by lazy {
      StringResource("string:todo_my_shifts", "todo_my_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370716, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527880, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340631, 34),
      ))
    }

@delegate:ResourceContentHash(399_449_473)
public val Res.string.todo_next_shift: StringResource by lazy {
      StringResource("string:todo_next_shift", "todo_next_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370755, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527927, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340666, 47),
      ))
    }

@delegate:ResourceContentHash(130_828_715)
public val Res.string.todo_ohs_expired: StringResource by lazy {
      StringResource("string:todo_ohs_expired", "todo_ohs_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370803, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 527983, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340714, 68),
      ))
    }

@delegate:ResourceContentHash(-111_033_815)
public val Res.string.todo_ohs_expiring: StringResource by lazy {
      StringResource("string:todo_ohs_expiring", "todo_ohs_expiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370888, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528148, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340783, 77),
      ))
    }

@delegate:ResourceContentHash(-689_852_712)
public val Res.string.todo_open: StringResource by lazy {
      StringResource("string:todo_open", "todo_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371011, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528359, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340906, 25),
      ))
    }

@delegate:ResourceContentHash(1_178_556_279)
public val Res.string.todo_open_roster: StringResource by lazy {
      StringResource("string:todo_open_roster", "todo_open_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 370966, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528294, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340861, 44),
      ))
    }

@delegate:ResourceContentHash(2_101_817_106)
public val Res.string.todo_policies: StringResource by lazy {
      StringResource("string:todo_policies", "todo_policies", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371086, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528454, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340969, 57),
      ))
    }

@delegate:ResourceContentHash(860_368_327)
public val Res.string.todo_policies_action: StringResource by lazy {
      StringResource("string:todo_policies_action", "todo_policies_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371041, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528401, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340932, 36),
      ))
    }

@delegate:ResourceContentHash(778_131_502)
public val Res.string.todo_publish: StringResource by lazy {
      StringResource("string:todo_publish", "todo_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371233, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528661, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341108, 84),
      ))
    }

@delegate:ResourceContentHash(908_697_699)
public val Res.string.todo_publish_changes: StringResource by lazy {
      StringResource("string:todo_publish_changes", "todo_publish_changes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371152, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528548, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341027, 80),
      ))
    }

@delegate:ResourceContentHash(-1_621_315_881)
public val Res.string.todo_reminded: StringResource by lazy {
      StringResource("string:todo_reminded", "todo_reminded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371302, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528762, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341193, 41),
      ))
    }

@delegate:ResourceContentHash(-923_978_741)
public val Res.string.todo_requests: StringResource by lazy {
      StringResource("string:todo_requests", "todo_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371397, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528897, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341272, 53),
      ))
    }

@delegate:ResourceContentHash(1_171_384_538)
public val Res.string.todo_requests_action: StringResource by lazy {
      StringResource("string:todo_requests_action", "todo_requests_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371356, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528840, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341235, 36),
      ))
    }

@delegate:ResourceContentHash(-626_880_287)
public val Res.string.todo_swap_asked: StringResource by lazy {
      StringResource("string:todo_swap_asked", "todo_swap_asked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371467, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 528991, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341326, 79),
      ))
    }

@delegate:ResourceContentHash(-792_356_386)
public val Res.string.todo_swap_rejected: StringResource by lazy {
      StringResource("string:todo_swap_rejected", "todo_swap_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371547, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529091, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341406, 78),
      ))
    }

@delegate:ResourceContentHash(1_989_496_065)
public val Res.string.todo_swaps_asked: StringResource by lazy {
      StringResource("string:todo_swaps_asked", "todo_swaps_asked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371650, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529214, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341485, 64),
      ))
    }

@delegate:ResourceContentHash(927_677_143)
public val Res.string.todo_title: StringResource by lazy {
      StringResource("string:todo_title", "todo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371719, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529299, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341550, 26),
      ))
    }

@delegate:ResourceContentHash(1_400_938_195)
public val Res.string.todo_unfilled: StringResource by lazy {
      StringResource("string:todo_unfilled", "todo_unfilled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371754, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529346, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341577, 77),
      ))
    }

@delegate:ResourceContentHash(-1_285_151_791)
public val Res.string.todo_view: StringResource by lazy {
      StringResource("string:todo_view", "todo_view", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371832, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529456, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341655, 25),
      ))
    }

@delegate:ResourceContentHash(1_509_760_059)
public val Res.string.top_bar_create_roster: StringResource by lazy {
      StringResource("string:top_bar_create_roster", "top_bar_create_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371858, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529506, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341681, 49),
      ))
    }

@delegate:ResourceContentHash(745_201_429)
public val Res.string.top_bar_month_picker_title: StringResource by lazy {
      StringResource("string:top_bar_month_picker_title", "top_bar_month_picker_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371908, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529576, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341731, 50),
      ))
    }

@delegate:ResourceContentHash(-2_043_746_164)
public val Res.string.top_bar_more: StringResource by lazy {
      StringResource("string:top_bar_more", "top_bar_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 371967, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529647, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341782, 36),
      ))
    }

@delegate:ResourceContentHash(-1_945_443_567)
public val Res.string.top_bar_next_year: StringResource by lazy {
      StringResource("string:top_bar_next_year", "top_bar_next_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372008, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529700, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341819, 37),
      ))
    }

@delegate:ResourceContentHash(1_599_740_222)
public val Res.string.top_bar_no_availability_request: StringResource by lazy {
      StringResource("string:top_bar_no_availability_request", "top_bar_no_availability_request", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372054, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529762, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341857, 79),
      ))
    }

@delegate:ResourceContentHash(1_249_985_855)
public val Res.string.top_bar_no_roster: StringResource by lazy {
      StringResource("string:top_bar_no_roster", "top_bar_no_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372146, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529882, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341937, 53),
      ))
    }

@delegate:ResourceContentHash(-2_076_683_797)
public val Res.string.top_bar_pick_month: StringResource by lazy {
      StringResource("string:top_bar_pick_month", "top_bar_pick_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372200, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 529960, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 341991, 50),
      ))
    }

@delegate:ResourceContentHash(-1_050_144_308)
public val Res.string.top_bar_previous_year: StringResource by lazy {
      StringResource("string:top_bar_previous_year", "top_bar_previous_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372259, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530031, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342042, 49),
      ))
    }

@delegate:ResourceContentHash(-1_702_901_990)
public val Res.string.top_bar_this_month: StringResource by lazy {
      StringResource("string:top_bar_this_month", "top_bar_this_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372309, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530097, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342092, 42),
      ))
    }

@delegate:ResourceContentHash(863_274_311)
public val Res.string.tracker_all_filled: StringResource by lazy {
      StringResource("string:tracker_all_filled", "tracker_all_filled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372360, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530164, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342135, 42),
      ))
    }

@delegate:ResourceContentHash(-1_070_310_825)
public val Res.string.tracker_answers: StringResource by lazy {
      StringResource("string:tracker_answers", "tracker_answers", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372415, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530219, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342178, 51),
      ))
    }

@delegate:ResourceContentHash(1_925_457_723)
public val Res.string.tracker_assign: StringResource by lazy {
      StringResource("string:tracker_assign", "tracker_assign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372471, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530287, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342230, 42),
      ))
    }

@delegate:ResourceContentHash(-367_689_918)
public val Res.string.tracker_current_step: StringResource by lazy {
      StringResource("string:tracker_current_step", "tracker_current_step", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372514, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530354, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342273, 52),
      ))
    }

@delegate:ResourceContentHash(-1_004_095_474)
public val Res.string.tracker_not_asked: StringResource by lazy {
      StringResource("string:tracker_not_asked", "tracker_not_asked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372571, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530427, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342326, 37),
      ))
    }

@delegate:ResourceContentHash(-798_494_169)
public val Res.string.tracker_publish: StringResource by lazy {
      StringResource("string:tracker_publish", "tracker_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372613, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530481, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342364, 47),
      ))
    }

@delegate:ResourceContentHash(-1_592_937_658)
public val Res.string.tracker_ready: StringResource by lazy {
      StringResource("string:tracker_ready", "tracker_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372665, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530569, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342412, 29),
      ))
    }

@delegate:ResourceContentHash(-1_364_746_633)
public val Res.string.tracker_shifts: StringResource by lazy {
      StringResource("string:tracker_shifts", "tracker_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372695, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530607, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342442, 38),
      ))
    }

@delegate:ResourceContentHash(-475_882_940)
public val Res.string.tracker_step_assignment: StringResource by lazy {
      StringResource("string:tracker_step_assignment", "tracker_step_assignment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372734, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530654, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342481, 47),
      ))
    }

@delegate:ResourceContentHash(-749_063_526)
public val Res.string.tracker_step_availability: StringResource by lazy {
      StringResource("string:tracker_step_availability", "tracker_step_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372782, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530718, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342529, 49),
      ))
    }

@delegate:ResourceContentHash(354_764_920)
public val Res.string.tracker_step_demand: StringResource by lazy {
      StringResource("string:tracker_step_demand", "tracker_step_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372840, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530784, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342579, 35),
      ))
    }

@delegate:ResourceContentHash(73_313_278)
public val Res.string.tracker_step_publication: StringResource by lazy {
      StringResource("string:tracker_step_publication", "tracker_step_publication", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372888, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530832, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342615, 48),
      ))
    }

@delegate:ResourceContentHash(1_602_893_306)
public val Res.string.training_card_confirmations: StringResource by lazy {
      StringResource("string:training_card_confirmations", "training_card_confirmations", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 372937, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 530893, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342664, 79),
      ))
    }

@delegate:ResourceContentHash(1_300_199_838)
public val Res.string.training_card_overdue: StringResource by lazy {
      StringResource("string:training_card_overdue", "training_card_overdue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373025, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 531049, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342744, 61),
      ))
    }

@delegate:ResourceContentHash(-609_085_070)
public val Res.string.training_card_to_do: StringResource by lazy {
      StringResource("string:training_card_to_do", "training_card_to_do", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373079, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 531123, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342806, 63),
      ))
    }

@delegate:ResourceContentHash(967_751_464)
public val Res.string.training_courses: StringResource by lazy {
      StringResource("string:training_courses", "training_courses", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373314, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 531438, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343017, 60),
      ))
    }

@delegate:ResourceContentHash(1_000_510_345)
public val Res.string.training_courses_empty: StringResource by lazy {
      StringResource("string:training_courses_empty", "training_courses_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373143, 170),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 531211, 226),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342870, 146),
      ))
    }

@delegate:ResourceContentHash(136_182_393)
public val Res.string.training_intro: StringResource by lazy {
      StringResource("string:training_intro", "training_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373371, 278),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 531511, 442),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343078, 230),
      ))
    }

@delegate:ResourceContentHash(-1_843_663_505)
public val Res.string.training_mine: StringResource by lazy {
      StringResource("string:training_mine", "training_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373746, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532050, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343381, 41),
      ))
    }

@delegate:ResourceContentHash(534_559_776)
public val Res.string.training_mine_empty: StringResource by lazy {
      StringResource("string:training_mine_empty", "training_mine_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373650, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 531954, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343309, 71),
      ))
    }

@delegate:ResourceContentHash(-523_101_403)
public val Res.string.training_state_done: StringResource by lazy {
      StringResource("string:training_state_done", "training_state_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373788, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532108, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343423, 51),
      ))
    }

@delegate:ResourceContentHash(-58_365_428)
public val Res.string.training_state_overdue: StringResource by lazy {
      StringResource("string:training_state_overdue", "training_state_overdue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373844, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532180, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343475, 54),
      ))
    }

@delegate:ResourceContentHash(-1_725_375_519)
public val Res.string.training_state_pending: StringResource by lazy {
      StringResource("string:training_state_pending", "training_state_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373903, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532263, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343530, 58),
      ))
    }

@delegate:ResourceContentHash(1_077_792_456)
public val Res.string.training_status_counts: StringResource by lazy {
      StringResource("string:training_status_counts", "training_status_counts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 373958, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532334, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343589, 62),
      ))
    }

@delegate:ResourceContentHash(-571_826_421)
public val Res.string.training_status_none: StringResource by lazy {
      StringResource("string:training_status_none", "training_status_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374021, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532405, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343652, 56),
      ))
    }

@delegate:ResourceContentHash(-2_004_102_002)
public val Res.string.training_team: StringResource by lazy {
      StringResource("string:training_team", "training_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374082, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532502, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343709, 29),
      ))
    }

@delegate:ResourceContentHash(-1_184_204_805)
public val Res.string.training_title: StringResource by lazy {
      StringResource("string:training_title", "training_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 374116, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 532544, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343739, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString44Resources(map: MutableMap<String, StringResource>) {
  map.put("tips_hours", Res.string.tips_hours)
  map.put("tips_my_empty", Res.string.tips_my_empty)
  map.put("tips_my_title", Res.string.tips_my_title)
  map.put("tips_new", Res.string.tips_new)
  map.put("tips_next_period", Res.string.tips_next_period)
  map.put("tips_people", Res.string.tips_people)
  map.put("tips_period_day", Res.string.tips_period_day)
  map.put("tips_period_invalid", Res.string.tips_period_invalid)
  map.put("tips_period_range", Res.string.tips_period_range)
  map.put("tips_period_week", Res.string.tips_period_week)
  map.put("tips_pools_empty", Res.string.tips_pools_empty)
  map.put("tips_pools_title", Res.string.tips_pools_title)
  map.put("tips_preview_enter_amount", Res.string.tips_preview_enter_amount)
  map.put("tips_preview_title", Res.string.tips_preview_title)
  map.put("tips_previous_period", Res.string.tips_previous_period)
  map.put("tips_replaces", Res.string.tips_replaces)
  map.put("tips_saved", Res.string.tips_saved)
  map.put("tips_tax_note", Res.string.tips_tax_note)
  map.put("tips_title", Res.string.tips_title)
  map.put("tips_waiting_for_hours", Res.string.tips_waiting_for_hours)
  map.put("tips_weight_invalid", Res.string.tips_weight_invalid)
  map.put("tips_weights_hint", Res.string.tips_weights_hint)
  map.put("tips_weights_title", Res.string.tips_weights_title)
  map.put("tips_your_share", Res.string.tips_your_share)
  map.put("todo_all_done", Res.string.todo_all_done)
  map.put("todo_all_done_hint", Res.string.todo_all_done_hint)
  map.put("todo_availability_due", Res.string.todo_availability_due)
  map.put("todo_availability_fill", Res.string.todo_availability_fill)
  map.put("todo_clock_reviews", Res.string.todo_clock_reviews)
  map.put("todo_clock_reviews_action", Res.string.todo_clock_reviews_action)
  map.put("todo_day_today", Res.string.todo_day_today)
  map.put("todo_day_tomorrow", Res.string.todo_day_tomorrow)
  map.put("todo_deadline", Res.string.todo_deadline)
  map.put("todo_earliest", Res.string.todo_earliest)
  map.put("todo_earliest_named", Res.string.todo_earliest_named)
  map.put("todo_hours_to_confirm", Res.string.todo_hours_to_confirm)
  map.put("todo_hours_to_confirm_action", Res.string.todo_hours_to_confirm_action)
  map.put("todo_marketplace", Res.string.todo_marketplace)
  map.put("todo_marketplace_action", Res.string.todo_marketplace_action)
  map.put("todo_medical_expired", Res.string.todo_medical_expired)
  map.put("todo_medical_expiring", Res.string.todo_medical_expiring)
  map.put("todo_missing_pay", Res.string.todo_missing_pay)
  map.put("todo_missing_pay_others", Res.string.todo_missing_pay_others)
  map.put("todo_missing_takings", Res.string.todo_missing_takings)
  map.put("todo_missing_takings_action", Res.string.todo_missing_takings_action)
  map.put("todo_my_shifts", Res.string.todo_my_shifts)
  map.put("todo_next_shift", Res.string.todo_next_shift)
  map.put("todo_ohs_expired", Res.string.todo_ohs_expired)
  map.put("todo_ohs_expiring", Res.string.todo_ohs_expiring)
  map.put("todo_open", Res.string.todo_open)
  map.put("todo_open_roster", Res.string.todo_open_roster)
  map.put("todo_policies", Res.string.todo_policies)
  map.put("todo_policies_action", Res.string.todo_policies_action)
  map.put("todo_publish", Res.string.todo_publish)
  map.put("todo_publish_changes", Res.string.todo_publish_changes)
  map.put("todo_reminded", Res.string.todo_reminded)
  map.put("todo_requests", Res.string.todo_requests)
  map.put("todo_requests_action", Res.string.todo_requests_action)
  map.put("todo_swap_asked", Res.string.todo_swap_asked)
  map.put("todo_swap_rejected", Res.string.todo_swap_rejected)
  map.put("todo_swaps_asked", Res.string.todo_swaps_asked)
  map.put("todo_title", Res.string.todo_title)
  map.put("todo_unfilled", Res.string.todo_unfilled)
  map.put("todo_view", Res.string.todo_view)
  map.put("top_bar_create_roster", Res.string.top_bar_create_roster)
  map.put("top_bar_month_picker_title", Res.string.top_bar_month_picker_title)
  map.put("top_bar_more", Res.string.top_bar_more)
  map.put("top_bar_next_year", Res.string.top_bar_next_year)
  map.put("top_bar_no_availability_request", Res.string.top_bar_no_availability_request)
  map.put("top_bar_no_roster", Res.string.top_bar_no_roster)
  map.put("top_bar_pick_month", Res.string.top_bar_pick_month)
  map.put("top_bar_previous_year", Res.string.top_bar_previous_year)
  map.put("top_bar_this_month", Res.string.top_bar_this_month)
  map.put("tracker_all_filled", Res.string.tracker_all_filled)
  map.put("tracker_answers", Res.string.tracker_answers)
  map.put("tracker_assign", Res.string.tracker_assign)
  map.put("tracker_current_step", Res.string.tracker_current_step)
  map.put("tracker_not_asked", Res.string.tracker_not_asked)
  map.put("tracker_publish", Res.string.tracker_publish)
  map.put("tracker_ready", Res.string.tracker_ready)
  map.put("tracker_shifts", Res.string.tracker_shifts)
  map.put("tracker_step_assignment", Res.string.tracker_step_assignment)
  map.put("tracker_step_availability", Res.string.tracker_step_availability)
  map.put("tracker_step_demand", Res.string.tracker_step_demand)
  map.put("tracker_step_publication", Res.string.tracker_step_publication)
  map.put("training_card_confirmations", Res.string.training_card_confirmations)
  map.put("training_card_overdue", Res.string.training_card_overdue)
  map.put("training_card_to_do", Res.string.training_card_to_do)
  map.put("training_courses", Res.string.training_courses)
  map.put("training_courses_empty", Res.string.training_courses_empty)
  map.put("training_intro", Res.string.training_intro)
  map.put("training_mine", Res.string.training_mine)
  map.put("training_mine_empty", Res.string.training_mine_empty)
  map.put("training_state_done", Res.string.training_state_done)
  map.put("training_state_overdue", Res.string.training_state_overdue)
  map.put("training_state_pending", Res.string.training_state_pending)
  map.put("training_status_counts", Res.string.training_status_counts)
  map.put("training_status_none", Res.string.training_status_none)
  map.put("training_team", Res.string.training_team)
  map.put("training_title", Res.string.training_title)
}
